import { PropTypes } from "prop-types";
import { useTranslation } from "react-i18next";
import OrderSummaryLineLayout from "../OrderSummaryLineLayout/OrderSummaryLineLayout";

const DropsSummaryLayout = ({ titleSection, dropAddressSection, packageTypeSection, notesSection }) => {
  const { t } = useTranslation();

  return (
    <>
      <OrderSummaryLineLayout titleSection={titleSection} contentSection={dropAddressSection} />

      <div className="d-flex flex-row flex-wrap col-12 px-0">
        <OrderSummaryLineLayout
          titleSection={t("utils.ui.orderSummary.packages")}
          contentSection={packageTypeSection}
        />

        {notesSection && (
          <OrderSummaryLineLayout titleSection={t("utils.ui.orderSummary.note")} contentSection={notesSection} />
        )}
      </div>
    </>
  );
};

DropsSummaryLayout.defaultProps = {
  notesSection: null,
};

DropsSummaryLayout.propTypes = {
  titleSection: PropTypes.node.isRequired,
  dropAddressSection: PropTypes.node.isRequired,
  packageTypeSection: PropTypes.node.isRequired,
  notesSection: PropTypes.node,
};

export default DropsSummaryLayout;
